import { DEFAULT_BASE_SIZE } from '@sr/templates/src';
import { Resume } from '@sr/types';
import React from 'react';
import { Button, DashboardIcon, NModal } from '../../ui';
import TemplatePicker from './TemplatePicker';

const TemplatePickerModal = ({
  resume,
  setLocalBaseSize,
}: {
  resume: Resume;
  setLocalBaseSize: (arg0: number) => void;
}) => {
  return (
    <NModal
      OpenButton={<OpenButton />}
      title="Choose a Template"
      isFullscreen={true}
      isDark={true}
    >
      <ModalContents resume={resume} setLocalBaseSize={setLocalBaseSize} />
    </NModal>
  );
};

function ModalContents({
  closeModal,
  resume,
  setLocalBaseSize,
}: {
  closeModal?: () => void;
  resume: Resume;
  setLocalBaseSize: (arg0: number) => void;
}) {
  return (
    <TemplatePicker
      resume={resume}
      onSelection={(style) => {
        closeModal && closeModal();
        setLocalBaseSize(
          style.customizations[style.activeTemplateId]?.baseSize ||
            DEFAULT_BASE_SIZE
        );
      }}
      initialGroup="all"
    />
  );
}

function OpenButton({ onClick }: { onClick?: () => void }) {
  return (
    <Button
      id="gi-preview-change-template-button"
      onClick={onClick}
      variant="secondaryDark"
      data-testid="open-template-picker"
      sx={{
        width: '100%',
        justifyContent: 'flex-start',
        backgroundColor: 'transparent',
        mr: 1,
        mb: 1,
        pl: 0,
        py: 2,
      }}
    >
      <DashboardIcon color="white" mr={3} />
      Change Template
    </Button>
  );
}

export default TemplatePickerModal;
